import { apiClient } from '@/services/api.client';
import type { Notification } from '@/contexts/NotificationContext';

export interface ApiNotification {
  id: string;
  type: string;
  title_key?: string;
  message_key?: string;
  payload?: Record<string, string>;
  read: boolean;
  created_at?: string;
}

function mapApiItem(item: ApiNotification): Notification {
  const payload = item.payload || {};
  return {
    id: item.id,
    title: item.title_key || '',
    message: item.message_key || '',
    titleKey: item.title_key,
    messageKey: item.message_key,
    type: item.type === 'application' ? 'application' : item.type === 'system' ? 'system' : 'info',
    timestamp: item.created_at ? new Date(item.created_at) : new Date(),
    read: !!item.read,
    vacanteId: payload.vacante_id,
    vacanteTitle: payload.vacante_title,
    applicationId: payload.application_id,
    candidateName: payload.candidate_name,
    candidateEmail: payload.candidate_email,
  };
}

export async function fetchNotifications(limit = 50): Promise<Notification[]> {
  const res = await apiClient.get<{ items: ApiNotification[] }>(`/api/notifications?limit=${limit}`);
  if (!res.success || !res.data?.items) return [];
  return res.data.items.map(mapApiItem);
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await apiClient.get<{ count: number }>('/api/notifications/unread-count');
  if (!res.success || res.data == null) return 0;
  return res.data.count ?? 0;
}

export async function markNotificationRead(id: string): Promise<boolean> {
  const res = await apiClient.patch(`/api/notifications/${id}/read`, {});
  return !!res.success;
}

export async function markAllNotificationsRead(): Promise<boolean> {
  const res = await apiClient.post('/api/notifications/mark-all-read', {});
  return !!res.success;
}

export async function deleteAllNotifications(): Promise<boolean> {
  const res = await apiClient.delete('/api/notifications');
  return !!res.success;
}
